export const environment = {
  url: 'https://dev.control.connect24.io',
  api_url: 'https://dev.apiv3.connect24.io',
  data_gmaps: {
    api_key: 'AIzaSyCCMYGk7PJN7GDFD8_GVI6wwzhK0U26Ghk',
    version: 'beta',
  },
};
